export default __webpack_public_path__ + "static/media/edit_icon.ccd557f8.svg";